import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDialog } from "hooks/useDialog";
import { PrimaryDialog } from "../PrimaryDialog";
import { Button } from "../Button";
import { MainInputInput } from "../MainInput";
import styles from "./PasswordDialog.module.scss";
import { useDispatch, useSelector } from 'react-redux';
import { login, resetAuthError, resetPassword } from "../../../reduxStore/slices/authSlice";

export const PasswordDialog = ({ version, onVersionMismatch }) => {
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const passwordDialog = useDialog();
  const dispatch = useDispatch();
  const [forgotPassword, setForgotPassword] = useState(false);
  const token = useSelector(state => state.authReducer.token);
  const authError = useSelector(state => state.authReducer.error);
  const [forgotPasswordEmail, setForgotPasswordEmail] = useState("");
  const [forgotPasswordMessage, setForgotPasswordMessage] = useState("");


  const handlePasswordChange = event => {
    dispatch(resetAuthError());
    setPassword(event.target.value);
  };

  const handleEmailChange = event => {
    // set authError to false when email changes
    dispatch(resetAuthError());
    setEmail(event.target.value);
  };

  const handleForgotPasswordChange = event => {
    setForgotPasswordEmail(event.target.value);
  }

  const handleForgotPasswordSubmit = () => {
    if (forgotPasswordEmail.trim() === "") {
      return;
    }
    dispatch(resetAuthError());
    dispatch(resetPassword(forgotPasswordEmail));
    setForgotPasswordMessage("If an account with this email exists, a reset link will be sent.");
  }

  const handlePasswordSubmit = (e) => {
    if (email === '' || password === '') {
      return;
    }
    dispatch(login({ email, password }));
  };

  useEffect(() => {
    if (window.location.protocol === "file:") {
      return;
    }

    const storedVersion = localStorage.getItem("appVersion");

    if (storedVersion !== version) {
      onVersionMismatch();
      localStorage.setItem("appVersion", version);
    }

    passwordDialog.openDialog();
  }, [version, passwordDialog, onVersionMismatch]);

  useEffect(() => {
    if (token) {
      navigate('/', { replace: true });
    }

  }, [token, navigate]);

  if (forgotPassword) {
    if (forgotPasswordMessage) {
      return (
        <PrimaryDialog
          mode="dark"
          size="sm"
          radius="radius-16"
          blurBackdrop
          open={true}
          onClose={() => setForgotPassword(false)}
          className={styles.dialogContainer}
        >
          <div>
            <h2>Forgot Password</h2>
            <p style={{ color: "#FFF"}}>{forgotPasswordMessage}</p>
            <span
              style={{ cursor: "pointer", color: "#55a7ff", textDecoration: "underline" }}
              onClick={() => setForgotPassword(false)}
            >
              Back to login
            </span>
          </div>
        </PrimaryDialog>
      );
    }

    return (
      <PrimaryDialog
        mode="dark"
        size="sm"
        radius="radius-16"
        blurBackdrop
        open={true}
        onClose={() => setForgotPassword(false)}
        className={styles.dialogContainer}
      >
        <div>
          <h2>Forgot Password</h2>
          <MainInputInput
            placeholder="Email"
            type="email"
            disabled={!!forgotPasswordMessage}
            value={forgotPasswordEmail}
            onEnter={handleForgotPasswordSubmit}
            onChange={handleForgotPasswordChange}
            error={false}
          />
          <span
            style={{ cursor: "pointer", color: "#55a7ff", textDecoration: "underline" }}
            onClick={() => setForgotPassword(false)}
          >
            Back to login
          </span>
          <Button className={styles.submitBtn} onClick={handleForgotPasswordSubmit}>Reset password</Button>
        </div>
      </PrimaryDialog>
    )
  }

  return (
    <PrimaryDialog
      mode="dark"
      size="sm"
      radius="radius-16"
      blurBackdrop
      open={passwordDialog.isOpen}
      onClose={() => {}}
      className={styles.dialogContainer}
    >
      <div>
        <h2>Enter Password</h2>
        <MainInputInput
          placeholder="Email"
          type="email"
          value={email}
          onEnter={handlePasswordSubmit}
          onChange={handleEmailChange}
          error={!!authError}
          hasErrorIcon
          helperText={authError ? "Incorrect password or username." : ""}
        />
        <MainInputInput
          placeholder="Password"
          type="password"
          value={password}
          onEnter={handlePasswordSubmit}
          onChange={handlePasswordChange}
          error={!!authError}
          hasErrorIcon
          helperText={authError ? "Incorrect password or username." : ""}
        />
        <span
          style={{ cursor: "pointer", color: "#55a7ff", textDecoration: "underline" }}
          onClick={() => setForgotPassword(true)}
        >
          Forgot password
        </span>
        <Button className={styles.submitBtn} onClick={handlePasswordSubmit}>
          OK
        </Button>
      </div>
    </PrimaryDialog>
  );
};
